export const patreonUrl = "https://www.patreon.com/fantasy_football/membership";
export const tgLink = "https://t.me/+r7cW6SfXBpJlYjIy";

export const primaryBlue = "#5d03b1";
export const primaryRed = "#101469";
export const primaryRedTransparent = "rgba(16, 24, 47, 0.7)";
export const gray = "gray";
export const green = "#4edd54";
export const red = "#f44336";
export const yellow = "rgb(255 222 1)";

export const teamColors = {
  ATM: ["rgb(185,38,53)", "#fff"],
  BAY: ["rgb(186,41,27)", "rgb(87,128,208)"],
  PSG: ["rgb(14,31,67)", "rgb(136,34,43)"],
  AJX: ["rgb(194,61,75)", "#fff"],
  ARS: ["#fff", "rgb(198,55,57)"],
  NAP: ["#fff", "rgb(58,136,193)"],
  ASM: ["#fff", "rgb(200,49,67)"],
  VIL: ["rgb(230,213,109)", "rgb(37,56,79)"],
  JUV: ["rgb(38,37,43)", "#fff"],
  DOR: ["rgb(242,213,82)", "rgb(32,30,19)"],
  LIV: ["rgb(165,35,56)", "rgb(165,35,56)"],
  SCP: ["#fff", "rgb(58,131,87)"],
  SLA: ["#fff", "rgb(203,53,66)"],
  RMA: ["#fff", "rgb(89,101,134	)"],
  BAR: ["rgb(158,47,69)", "rgb(31,45,94)"],
  ATA: ["rgb(35,43,59)", "rgb(86,148,237)"],
  OLY: ["rgb(191,57,52)", "#fff"],
  CHE: ["rgb(51,79,166)", "#fff"],
  LEV: ["rgb(29,23,27)", "rgb(233,154,176)"],
  OM: ["#fff", "rgb(121,207,240)"],
  NEW: ["rgb(64,63,71)", "#fff"],
  ATH: ["rgb(207,56,59)", "#fff"],
  GAL: ["rgb(124,30,50)", "rgb(232,152,60)"],
  MCI: ["rgb(137,182,223)", "rgb(51,75,102)"],
  INT: ["rgb(19,20,37)", "rgb(47,103,198)"],
  PSV: ["rgb(218,91,85)", "#fff"],
  STG: ["rgb(55,74,111)", "rgb(239,211,82)"],
  FRA: ["rgb(26,24,25)", "rgb(217,78,56)"],
  TOT: ["#fff", "rgb(37,43,83)"],
  SLB: ["#fff", "rgb(197,46,48)"],
  BRU: ["rgb(83,153,216)", "rgb(23,22,24)"],
  BOD: ["rgb(242,216,73)", "rgb(14,15,13)"],
  PAF: ["rgb(42,75,111)", "rgb(141,185,205)"],
  KAI: ["rgb(235,202,83)", "rgb(48,48,48)"],
  KAR: ["rgb(82,81,87)", "#fff"],
  CPH: ["rgb(54,106,178)", "#fff"],
};
